import { cn } from "@/lib/utils";

export const SelectField = ({ id, label, value, onChange, options, placeholder, testId, className, srLabel }) => (
  <div className={cn("flex min-w-0 flex-col gap-1.5", className)}>
    <label htmlFor={id} className={cn("field-label", srLabel && "sr-only")}>
      {label}
    </label>
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className="field" data-testid={testId}>
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </div>
);
